// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";



// 引入 我们准备好的 store
import store from '@/store/index.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

Vue.prototype.$apiFun = apiFun;//请求接口api

Vue.config.productionTip = false

// 路由改成按需加载后多了一个失败模式：弱网下分包没拉下来，vue-router
// 不会重试，用户就卡在空白页。这里刷一次救回来，并用 sessionStorage 打标防死循环。
router.onError(function (err) {
  var msg = (err && err.message) || '';
  if (!/Loading( CSS)? chunk \S* failed/i.test(msg)) {
    return;
  }
  if (sessionStorage.getItem('chunk_reloaded')) {
    return;
  }
  sessionStorage.setItem('chunk_reloaded', '1');
  window.location.reload();
});

router.afterEach((to, from, next) => {
  sessionStorage.removeItem('chunk_reloaded'); // 进得去就清标，下次出问题还能救一次

  window.scrollTo(0, 0);//没到一个新的页面 就自动回顶

});
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
  console.log(token)
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    if (localStorage.getItem('token')) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      next({
        path: '/login', // 未登录则跳转至login页面
        query: { redirect: to.fullPath } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      });
    }
  } else {
    next();
  }


});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,//使用store
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js